import React, { Component, PropTypes } from 'react';
import { NitroLoading } from 'nitro-components';

import BookmarksPanel from '../../common/Bookmarks/containers/BookmarksPanel';
import DataProvider from '../dataProvider';

import {
  DRIVER_ALERT_TEXT,
  VEHICLE_ALERT_TEXT,
  BOOKMARK_HINT_TEXT,
  BOOKMARKED
} from '../content';
import { HeaderContainer, ProfileSidePanel } from '../components';

import { transformContactsToSidePanel } from '../helpers';

import NotesPanel from './NotesPanel';

import VehicleDriverDetails from '../../relocations/driver/components/VehicleDriverDetails';
import AllocateDiffDriverNotify from '../../relocations/driver/components/AllocateDiffDriverNotify';
import AllocateDifferentDriver from '../../relocations/driver/components/AllocateDifferentDriver';

class ProfileHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0, // place holder id for both vehiucle profile and driver profile.
      // in case of driver profile id holds the DriverID and
      // in case of vehicle profile id holds the leaseId
      allocateDifferentDriverNotifyOpen: false,
      allocateDifferentDriverOpen: false,
      allocationDetailsOpen: false
    };

    this.onStudClick = this.onStudClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    // whenever the dashboard type is driver and driver id is changed then set the id .
    if (
      nextProps.dashboardType === 'driver' &&
      this.props.profile.DriverId !== nextProps.profile.DriverId
    ) {
      const { DriverId } = nextProps.profile;
      this.setState({
        id: DriverId
      });
      // whenever the dashboard type is vehicle and leaseid is changed then set the id .
    } else if (
      nextProps.dashboardType === 'vehicle' &&
      this.props.profile.LeaseId !== nextProps.profile.LeaseId
    ) {
      const { LeaseId } = nextProps.profile;
      this.setState({
        id: LeaseId
      });
    }
  }

  closeProfileSidePanel = () => {
    // profile side panel open and close is handled by redux so that it works both for minimal and normal header
    this.props.actions.setSidePanel({ showProfileSidePanel: false });
  };

  closeNotesSidePanel = () => {
    // notes side panel open and close is handled by redux so that it works both for minimal and normal header
    this.props.actions.setSidePanel({ showNotesSidePanel: false });
  };

  onStudClick = type => {
    const { CountryCode, CompanyCode, LeaseId } = this.props.profile;

    this.setState({
      selectedStud: type
    });
    switch (type) {
      case 'contact':
        this.props.actions.setSidePanel({ showProfileSidePanel: true });
        break;
      case 'notes':
        this.props.actions.fetchProfileNotes(
          {},
          this.state.id,
          this.props.dashboardType
        );

        this.props.actions.setSidePanel({ showNotesSidePanel: true });
        break;
      case 'realloc':
        this.props.fetchDriverAllocationDetails({
          countryCode: CountryCode,
          companyCode: CompanyCode,
          id: LeaseId
        });
        this.setState({
          allocationDetailsOpen: true
        });
        break;
      default:
        break;
    }
  };

  addNotes = notes => {
    // add notes for both vehicle profile and driver profile with id set respectiveley
    this.props.actions.addCustomNotes(
      this.state.id,
      notes,
      this.props.auth.firstName,
      this.props.auth.lastName,
      this.props.dashboardType
    );
  };

  onBookmarkClick = (id, title, dashboardType) => {
    const currentBookMarkStatus = this.props.profile.Bookmarked;
    const newBookMarkStatus = !currentBookMarkStatus;

    this.props.actions.setBookmark(id, newBookMarkStatus, dashboardType);

    // refresh the bookmarks, since we are doing a state change for bookmarks.
    // when the refresh bookmarks is set true, when ever we open the boookmarks panel we reeload the bookmarks data.
    this.props.globalActions.refreshBookmarks(true);

    if (newBookMarkStatus) {
      // do the notify bar
      this.props.notify({
        type: 'bookmark',
        time: 15000,
        size: 30,
        title,
        message: <div onClick={this.showAllBookmarks}>{BOOKMARK_HINT_TEXT}</div>
      });
    } else {
      this.props.closeNotify();
    }
  };

  /** Allocate different Driver NOTIFY click --END * */
  closeSidePanel = pageId => {
    switch (pageId) {
      case 'differentDriverNotify':
        this.setState({
          allocateDifferentDriverNotifyOpen: false
        });
        break;

      case 'differentDriver':
        this.setState({
          allocateDifferentDriverOpen: false
        });
        break;
      case 'vehicleAllocation': {
        this.setState({
          allocationDetailsOpen: false
        });
        break;
      }
      default:
        console.error('invalid pageId');
        break;
    }
  };
  backSidePanel = pageId => {
    this.setState({
      allocationDetailsOpen: true
    });
    switch (pageId) {
      case 'differentDriverNotify': {
        this.closeSidePanel('differentDriverNotify');
        break;
      }

      case 'differentDriver': {
        this.closeSidePanel('differentDriver');
        break;
      }

      default: {
        console.error('invalid pageId');
        break;
      }
    }
  };

  /** Allocate different Driver NOTIFY click --START * */
  onAllocateDifferentDriverClick = () => {
    this.setState({ allocateDifferentDriverNotifyOpen: true });
    this.closeSidePanel('vehicleAllocation');
  };

  onAllocateDifferentDriverNotifyContinue = () => {
    this.setState({ allocateDifferentDriverOpen: true });
    this.closeSidePanel('differentDriverNotify');
  };
  showAllBookmarks = () => {
    // bookmarks side panel open is handled by the global actions.
    this.props.globalActions.openBookmarksSidePanel();
  };
  render() {
    const { profile, minimalMode, notes, common, dashboardType } = this.props;

    const showBookmarksPanel = common ? common.openBookmarks : false;

    const {
      ProtentiallySuspended,
      DriverFirstName,
      DriverSurname,
      NotesCount,
      SafetyRating,
      ContactInfo,
      fetchingProfile,
      fetchingNotes,
      MakeModel,
      RegistrationNumber,
      Indicator,
      ImageKey,
      Bookmarked,
      showProfileSidePanel,
      showNotesSidePanel
    } = profile;
    const { id } = this.state;

    let title, subTitle, alert, avatar, notesPlaceHolder, bookmarksTitle;

    // set the individual property based on vehicle profile or driver profile
    const studs = [
      {
        type: 'notes',
        disabled: Boolean(!this.state.id),
        icon: 'notes',
        label: 'NOTES',
        count: NotesCount || ''
      },
      {
        type: 'contact',
        icon: 'phone',
        label: 'CONTACT DRIVER'
      }
    ];
    if (dashboardType === 'driver') {
      title = `${DriverFirstName} ${DriverSurname}`;
      subTitle = SafetyRating;
      alert = ProtentiallySuspended ? DRIVER_ALERT_TEXT : null;
      // id = DriverId;
      avatar = null;
      notesPlaceHolder = `${DriverFirstName} ${DriverSurname}`;
      bookmarksTitle = `${DriverFirstName} ${DriverSurname} ${BOOKMARKED}`;
    } else {
      title = `${MakeModel}`;
      subTitle = RegistrationNumber;
      alert = Indicator ? VEHICLE_ALERT_TEXT : null;
      avatar = ImageKey;
      // id = LeaseId;
      notesPlaceHolder = RegistrationNumber;
      bookmarksTitle = `${RegistrationNumber} ${BOOKMARKED}`;

      studs.push({
        type: 'realloc',
        icon: 'edit',
        label: 'CHANGE DRIVER'
      });
    }

    // So as to prevent the intial render of the page withour tabs being loaded
    return (
      <div>
        {fetchingProfile ? (
          <NitroLoading position="center" size={60} />
        ) : (
          <div>
            <HeaderContainer
              bookmarkClick={() =>
                this.onBookmarkClick(id, bookmarksTitle, dashboardType)
              }
              bookmarkActive={Bookmarked}
              title={title}
              alert={alert}
              subTitle={subTitle}
              avatar={avatar}
              // add the export stud, notes stud and the contact button to the studs list
              studs={studs}
              minimalMode={minimalMode}
              onStudClick={this.onStudClick}
              dashboardType={dashboardType}
            />
            {showBookmarksPanel && <BookmarksPanel title="Bookmarks" />}

            {showProfileSidePanel && (
              <ProfileSidePanel
                open={showProfileSidePanel}
                close={this.closeProfileSidePanel}
                title="Contact"
                sidePanelData={transformContactsToSidePanel(
                  `${title}`,
                  ContactInfo
                )}
              />
            )}

            {showNotesSidePanel && (
              <NotesPanel
                isOpen={showNotesSidePanel}
                close={this.closeNotesSidePanel}
                notesData={notes}
                title="Notes"
                fetchingNotesData={fetchingNotes}
                placeHolder={`Add new notes for ${notesPlaceHolder} ...`}
                add={this.addNotes}
              />
            )}
            {/*
                step 1 fetch driver allocations details
            */}
            {this.state.allocationDetailsOpen && (
              <VehicleDriverDetails
                isOpen={this.state.allocationDetailsOpen}
                close={this.closeSidePanel}
                driverAllocationDetails={this.props.driverAllocationDetails}
                fetchingDriverAllocationDetails={
                  this.props.fetchingDriverAllocationDetails
                }
                onAllocateDifferentDriverClick={
                  this.onAllocateDifferentDriverClick
                }
              />
            )}
            {/*
                step 2 fetch driver allocations confirmation/notify
            */}
            {this.state.allocateDifferentDriverNotifyOpen && (
              <AllocateDiffDriverNotify
                isOpen={this.state.allocateDifferentDriverNotifyOpen}
                close={this.closeSidePanel}
                back={this.backSidePanel}
                allocateDiffDriverNotifyContinue={
                  this.onAllocateDifferentDriverNotifyContinue
                }
              />
            )}
            {/*
                step 3 assign existing/new driver
            */}
            {this.state.allocateDifferentDriverOpen && (
              <AllocateDifferentDriver
                isOpen={this.state.allocateDifferentDriverOpen}
                close={this.closeSidePanel}
                back={this.backSidePanel}
                vehicleDetails={this.props.driverAllocationDetails}
                country={this.props.country}
                company={this.props.company}
                driverProfile={null}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

ProfileHeader.propTypes = {
  actions: PropTypes.shape({}),
  globalActions: PropTypes.shape({}),
  notify: PropTypes.func,
  closeNotify: PropTypes.func,
  profile: PropTypes.object,
  notes: PropTypes.array,
  minimalMode: PropTypes.bool,
  onStudClick: PropTypes.func,
  fetchingProfile: PropTypes.bool,
  common: PropTypes.object,
  dashboardType: PropTypes.string
};

ProfileHeader.defaultProps = {
  minimalMode: false,
  actions: null,
  globalActions: null,
  notify: () => {},
  closeNotify: () => {},
  profile: null,
  notes: null,
  onStudClick: () => {},
  fetchingProfile: true,
  common: null,
  dashboardType: null
};

export default DataProvider(ProfileHeader);



// WEBPACK FOOTER //
// ./src/features/dashboard/containers/ProfileHeader.js